import React, {useMemo} from 'react';
import {Select} from "antd";

const MaillerFaq = ({selectedTemplate, onChange, templates}) => {

	const templatesFilter = useMemo(() => {
		return templates
			.filter((item) => item.template_type === 2)
			.sort((a, b) => a.template_libelle.localeCompare(b.template_libelle))
			.map((item) => {
				return {
					value: item.template_id,
					label: item.template_libelle
				}
			});
	}, [templates]);

	return (
		<Select
			size={"large"}
			showSearch
			allowClear
			optionFilterProp="label"
			style={{width: '100%'}}
			value={selectedTemplate}
			onChange={onChange}
			placeholder="Choix F.A.Q"
			options={templatesFilter}
		/>
	);
};

export default MaillerFaq;